import { useTranslation } from 'react-i18next';
import { FeatherIcon } from './FeatherIcon';

/** The × inside an account search box: shown while it holds text, since that text is
 *  remembered and a filtered list could otherwise look like missing Accounts. */
export function SearchClearButton({ value, onClear, size = 14 }: { value: string; onClear: () => void; size?: number }) {
  const { t } = useTranslation('common');
  if (!value) return null;
  return (
    <button
      type="button"
      className="search-clear-btn"
      onClick={onClear}
      // Keep the input focused (and the phone keyboard up) on tap.
      onMouseDown={(e) => e.preventDefault()}
      title={t('layout.clearSearch')}
      aria-label={t('layout.clearSearch')}
    >
      <FeatherIcon name="x" size={size} />
    </button>
  );
}
